// register the plugin on vue
import Vue from 'vue';
import axios from 'axios';
import router from '../router'
import { isExpired, logOut } from './auth'

Vue.prototype.$axios = axios

// APIのエンドポイントを設定（docker-compose.ymlに記載）
Vue.prototype.$axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

// ログイン永続化
if (sessionStorage.getItem('conan-zemi')) {
  const strageData = JSON.parse(sessionStorage.getItem('conan-zemi'));
  // sessionStrageにデータがあったらヘッダーに値を設定する
  if (typeof strageData.user && strageData.user?.accessToken) {
      Vue.prototype.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      Vue.prototype.$axios.defaults.headers.common['client']       = strageData.user.client;
      Vue.prototype.$axios.defaults.headers.common['uid']          = strageData.user.uid;
  }
}

Vue.prototype.$axios.interceptors.request.use(
	(request) => {
    // request時に一定時間操作がなかったら
    if (request.url !== '/api/v1/auth/sign_out' && isExpired()) {
      logOut()
      request.url = '/api/v1/auth/sign_out'
      request.method = 'delete'
      request.data = undefined
      if (router.history.current.name !== 'SignIn') {
        router.push('/sign_in')
      }

    }

    return request
  }
)

Vue.prototype.$axios.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
		// 認証が切れた時の処理（ログイン失敗）
		if (error.response.status == 401) {

      return Promise.reject(error)
    }
    // バリデーション失敗時の処理
		else if (error.response.status == 422) {

      return Promise.reject(error)
    }

    else {
      return Promise.reject(error)
    }
	}
)
